// extracted by mini-css-extract-plugin
module.exports = {"activeTab":"sidebar_activeTab__2Kj8L","arrow":"sidebar_arrow__17EJo"};